import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { Field, reduxForm } from 'redux-form';
import { toastr } from 'react-redux-toastr';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import { AdminApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';
import { convertDollarsToMills } from '../../../utils/helpers/currency';

import {
  InputField,
  DateField,
  SelectField,
  required,
  maxLength,
  minLength,
  number,
  maxValue,
  minValue,
  email,
  password,
  passwordBlank,
  matchField,
  dateGtnToday,
  isValidSlug,
  url
} from '../../form';

import { humanize } from '../../../utils/helpers/text_formatters';

class Form extends Component {
  onFormSubmit(values, hideModal = true) {
    const {
      dispatch,
      resourceName,
      handleHide,
      formAction,
      resource,
      resourceData,
      reset
    } = this.props;
    const data = this.sanitizeData(resourceName, values);
    const args = formAction === 'Update' ? [resource.uuid, data] : [data];

    dispatch(setLoader('adminResourceForm'));

    dispatch(AdminApi.actions[`${resourceName}${formAction}`].post(...args, (error, success) => {
      dispatch(removeLoader('adminResourceForm'));
      if (success) {
        let collection = [...resourceData.data];
        if (formAction === 'Update') {
          collection = [...resourceData.data].map((obj) => {
            return obj.uuid === success.data.uuid ? success.data : obj;
          });
          toastr.success('Successfully updated record!');
        } else if (formAction === 'Create') {
          collection.unshift(success.data);
          toastr.success('Successfully created record!');
        }

        dispatch({
          type: AdminApi.events[resourceName].actionSuccess,
          syncing: false,
          data: { ...resourceData, data: collection, meta: { ...resourceData.meta } }
        });

        if (resourceName === 'website') {
          dispatch(AdminApi.actions.websiteTemplate());
        }

        if (hideModal) handleHide();
        if (!hideModal) reset();
      }
    }));
  }

  onAddAnother(values) {
    this.onFormSubmit(values, false);
  }


  getValidation(vals) {
    const { resourceName } = this.props;
    const validations = [];
    vals.forEach(v => {
      const value = v.split(':')[1];
      switch (true) {
        case /required/.test(v): {
          validations.push(required);
          break;
        }
        case /email/.test(v): {
          validations.push(email);
          break;
        }
        case /number/.test(v): {
          validations.push(number);
          break;
        }
        case /match_field/.test(v): {
          validations.push(matchField(value, resourceName));
          break;
        }
        case /password_blank/.test(v): {
          validations.push(passwordBlank);
          break;
        }
        case /password/.test(v): {
          validations.push(password);
          break;
        }
        case /max_length/.test(v): {
          validations.push(maxLength(parseInt(value, 10)));
          break;
        }
        case /min_length/.test(v): {
          validations.push(minLength(parseInt(value, 10)));
          break;
        }
        case /min_value/.test(v): {
          validations.push(minValue(parseInt(value, 10)));
          break;
        }
        case /max_value/.test(v): {
          validations.push(maxValue(parseInt(value, 10)));
          break;
        }
        case /date_gt_today/.test(v): {
          validations.push(dateGtnToday);
          break;
        }
        case /isValidSlug/.test(v): {
          validations.push(isValidSlug);
          break;
        }
        case /url/.test(v): {
          validations.push(url);
          break;
        }
        default:
          break;
      }
    });

    return validations;
  }

  getInputField(f, i) {
    const { resourceName } = this.props;

    return (
      <Field
        key={`${resourceName}-${f.field}-${i}`}
        type={f.type || 'text'}
        name={`${resourceName}[${f.field}]`}
        placeholder={humanize(f.field)}
        label={humanize(f.field)}
        disabled={f.disabled}
        component={f.options ? SelectField : InputField}
        options={f.options ? f.options : null}
        validate={this.getValidation(f.validation)}
        multiple={f.options && ['roles', 'integrations'].includes(f.field) ? true : false}
        normalize={f.options ? (e) => this.optionNormalize(e) : null}
      />
    );
  }

  getDateField(f, i) {
    const { resourceName } = this.props;
    return (
      <Field
        key={`${resourceName}-${f.field}-${i}`}
        name={`${resourceName}[${f.field}]`}
        placeholder={humanize(f.field)}
        label={humanize(f.field)}
        disabled={f.disabled}
        component={DateField}
        validate={this.getValidation(f.validation)}
      />
    );
  }

  optionNormalize(e) {
    if (e === null) {
      return null;
    }

    if (Array.isArray(e)) {
      return e.map(s => s.value);
    }

    return e.value;
  }

  handleShow() {
    const { handleHide, resource, onShow } = this.props;
    handleHide();
    onShow(resource.uuid, resource);
  }

  sanitizeData(resourceName, values) {
    let data = {};

    switch (resourceName) {
      case 'website': {
        const cpa = values.website.cpa === undefined ? 0 : values.website.cpa;
        const convertToMills = { cpa: parseFloat(convertDollarsToMills(cpa)), cpc: parseFloat(convertDollarsToMills(values.website.cpc)) };
        data = { website: { ...values.website, ...convertToMills } };
        break;
      }
      case 'advertiser': {
        const roles = [];
        values.advertiser.roles.map(v => roles.push(v));
        data = { advertiser: { ...values.advertiser, roles } };
        break;
      }
      default: {
        data = { ...values };
      }
    }

    return data;
  }

  renderFields() {
    const { formFields, attributes } = this.props;
    return (
      <div>
        {formFields.map((f, i) => {
          switch (attributes[f.field]) {
            case 'string':
              return this.getInputField(f, i);
            case 'datetime':
              return this.getDateField(f, i);
            default:
              return this.getInputField(f, i);
          }
        })}
      </div>
    );
  }

  render() {
    const { show, handleHide, handleSubmit, heading, formAction, isLoading } = this.props;
    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>

        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className='m-t'
        >
          <Modal.Body>
            {this.renderFields()}
            {
              ['New Account', 'Editing Account'].includes(heading) &&
              'For self serve advertisers status cannot be changed manually'
            }
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={handleHide}>Close</Button>
            {formAction === 'Update' ?
              <Button
                bsStyle='success'
                onClick={this.handleShow.bind(this)}
              >
                View
              </Button> : null}
            {formAction === 'Create' ?
              <Button
                bsStyle='primary'
                loading={isLoading}
                onClick={handleSubmit(this.onAddAnother.bind(this))}
              >
                Create and add another
              </Button> : null}
            <Button
              type='submit'
              loading={isLoading}
              bsStyle='info'
            >
              {formAction || 'Submit'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'AdminResourceForm'
});

const ResourceModal = connectModal({
  name: 'AdminResourceModal'
});

const mapStateToProps = (state) => {
  const { loader, modal: { AdminResourceModal } } = state;
  const isLoading = loader.includes('adminResourceForm');
  const resource = get(AdminResourceModal, 'props.resource', {});
  const resourceName = get(AdminResourceModal, 'props.resourceName', null);
  const formFields = get(AdminResourceModal, 'props.formFields', []);
  const resourceData = get(state, `admin.${resourceName}.data`, {});
  const attributes = get(AdminResourceModal, 'props.attributes', {});

  const initialValues = {};
  if (resourceName) {
    initialValues[resourceName] = {};
    formFields.forEach((f) => {
      if (attributes[f.field] === 'boolean') {
        initialValues[resourceName][f.field] = `${resource[f.field]}`;
      } else {
        initialValues[resourceName][f.field] = resource[f.field] || f.default_value;
      }
    });
  }

  return { isLoading, initialValues, resourceData };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(Form)));
